export default {
  NA: 'N/A',
  NotAvailable: 'NotAvailable',
};
